export default __webpack_public_path__ + "static/media/gal4.ea3c4fe4.jpeg";